import { IBaseDataParser } from "../../../core/src/server/parsers/IBaseDataParser";
import { IVendorData } from "../../model/IVendorData";

// TODO remove or add relevant data

export default class VendorDataParser implements IBaseDataParser<IVendorData> {
    check(data: any): boolean {
        return data && !data.errorCode;
    }

    parse(data): IVendorData {

        let result;
        result = {
            grids: data.config?.grids,
            freeGames: data.stats? data.stats.freespins : data.freespins
        };

        return result;
    }

  

}